export default "__VITE_ASSET__DkfaIxj4__"